import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ISubTeamDTO } from "../../../../../../api-services/football/admin/manage-football-team-service";
import { manageFootballTeamService } from "../../../../../../commons";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";

export interface ITeamAddOption {
  teamId: number;
  subTeamData: ISubTeamDTO;
}

interface ITeamAdd {
  subTeamAddResponseStatus: StatusEnum;
}

const initialState: ITeamAdd = {
  subTeamAddResponseStatus: StatusEnum.Idle,
};

export const subTeamAdd = createAsyncThunk("manage/subTeamAdd", async (options: ITeamAddOption, thunkAPI) => {
  try {
    const subTeamAddResponse = await manageFootballTeamService.addSubTeam(options.teamId, options.subTeamData);
    return subTeamAddResponse;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

const manageTeamAddSlice = createSlice({
  name: "subTeamAdd",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(subTeamAdd.pending, (state) => {
        state.subTeamAddResponseStatus = StatusEnum.Loading;
      })
      .addCase(subTeamAdd.fulfilled, (state) => {
        state.subTeamAddResponseStatus = StatusEnum.Succeeded;
      })
      .addCase(subTeamAdd.rejected, (state) => {
        state.subTeamAddResponseStatus = StatusEnum.Failed;
      });
  },
});

export default manageTeamAddSlice.reducer;
